import {
    StateController,
    platform
} from "@aceroll/core";

class IdleController extends StateController {
    constructor() {
        super("max.win");
    }

    onStart() {
        platform.setMaxWin();
        serverData.setCurrentResponse();
        this.stop();
    }

    onStop() { }
}

export default IdleController;